import React, { Component } from 'react'
import { checkTranslation, conditionalWidth, imageAddress, translate } from "../../utils/useful";
import FixedView from "../../components/FixedView";
import Collapsible from "react-collapsible";
import StagesManager from "../../components/StagesManager";
import IntractionActionsList2 from "../../components/IntractionActionsList2";
import DirectoryPathIndicator from './DirectoryPathIndicator';
import IntractionActionsList from '../../components/IntractionActionsList';
import AppletFrame from '../../components/header/AppletFrame';
import DynamicFrame from '../../components/header/DynamicFrame';
import importedIcons from '../../components/inputs/icons';
import DriveFrame from '../../components/header/DriveViewType';
import SelectApplet from '../../components/useful/SelectApplet';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

class headerDrive extends Component {

    state = {
        // show: false,

        // pages: [
        //     { key: 'dashboard', label: '{{lang}}All Files', icon: '/assets/icons/applets/drive/all-files-white.svg', icon2: '/assets/icons/applets/drive/all-files-3.svg' },
        //     { key: 'starred', label: '{{lang}}Starred', icon: '/assets/icons/applets/drive/starred-white.svg', icon2: '/assets/icons/applets/drive/starred-orange.svg' },
        //     { key: 'trashed', label: '{{lang}}Trash', icon: '/assets/icons/applets/drive/trash-white.svg', icon2: '/assets/icons/applets/drive/trash-orange.svg' },
        //     { key: 'shared', label: '{{lang}}Shared with me', icon: '/assets/icons/applets/drive/share-white.svg', icon2: '/assets/icons/applets/drive/share-orange.svg' },
        // ],
        // applets: [
        //     { name: 'Company', icon: '/assets/profile-def.png' },
        //     { name: 'Family', icon: '/assets/profile-def.png' },
        //     { name: 'Friends', icon: '/assets/profile-def.png' },
        // ],
        // currentPage: 'dashboard',
        // isOpen: { 0: true },
        listStyle: false,
        showSearchBox: false,
        // showItems: true,
        sorted: true,
        // more: true,
        // showSortFixedView: false,
        sorting: [
            { name: '{{lang}}drives.Name', key: 'name', select: false },
            { name: '{{lang}}drives.Date modified', key: 'modifiedDate', select: false },
        ],
        show: false,
        viewStyle: 'details'
    }

    componentDidMount() {
    }

    componentDidUpdate() {

        // console.log('cureeeeeeeeeeeeeeeeentsort', this.props)
        // console.log('this.props.paths', this.props.paths)
    }

    viewStyleShow = (view) => {
        if (view == 'mediumIcons' || view == 'details') {
            this.setState({ viewStyle: view })
            this.props.setStateProps("view", view)
        }
    }

    folderShow = () => {
        let listStyle = this.state.listStyle
        this.setState({ listStyle: !listStyle })
        if (listStyle === true) {
            this.props.setStateProps("view", 'list')
        }
        else {
            this.props.setStateProps("view", 'grid')
        }
    }

    filterFiles = (value) => {
        this.props.filterFiles(value)
    }

    closeSortFixedView = () => {
        const actions = {
            click: 'click',
            // scroll: 'scroll'
        }
        Object.keys(actions).forEach(key => {
            this.container.addEventListener(key, (e) => {
                let inside = e.target.closest('.sort-fixedview')
                if (this.state.sorted && !inside) {
                    this.setState({ sorted: false })
                }
            })
        });
    }

    sortFixedView = () => {
        let sorted = this.state.sorted
        this.setState({ sorted: !sorted })
        if (sorted == true) {
            this.fixedView.showView()
        }
        else {
            this.fixedView.hideView()
        }
    }

    moreFixedViewSet = () => {
        let more = this.state.more
        this.setState({ more: !more })
        if (more == true) {
            this.moreFixedView.showView()
        }
        else {
            this.moreFixedView.hideView()
        }
    }

    showItemsSet = () => {
        let showItems = this.state.showItems
        if (this.props?.leftSideBarStage == false) {
            if (this.state.showSearchBox == true) {
                showItems = false
            }
            else {
                showItems = true
            }
        }
        else {
            showItems = false
        }
        this.setState({ showItems })
    }

    chengecollaps = (item, index) => {
        let isOpen = this.state.isOpen
        isOpen = {}
        isOpen[index] = !isOpen[index]
        this.setState({ isOpen })
        this.props.changeAppletsTab(item, index)
    }

    changePageSubMenu = (title) => {
        this.stageManager.changeStage(title)
    }

    lastPage = () => {
        this.stageManager.lastStage()
    }

    uploadModal = () => {
        console.log('this.props.currentApplet', this.props.currentApplet)
        if (this.props.currentApplet == '') {
            // this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.Action Fail', description: 'Please select applet first' })
            this.newView.hideView()
            this.selectApplet.appletViewModal.open()
            this.props.setData('newUpload', true, 'FileManager')
            // this.selectApplet.appletView.showView()
        }
        else {
            this.props.uploadModal()
        }
    }

    functionHandler = () => {
        if (this.props.newFolder) {
            this.folderModal()
        }
        if (this.props.newUpload) {
            this.uploadModal()
        }
    }

    folderModal = () => {
        console.log('this.props.currentApplet', this.props.currentApplet)
        if (this.props.currentApplet == '') {
            // this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.Action Fail', description: 'Please select applet first' })
            this.newView.hideView()
            this.selectApplet.appletViewModal.open()
            this.props.setData('newFolder', true, 'FileManager')
            // this.selectApplet.appletView.showView()
        }
        else {
            this.props.folderModal()
        }
    }
    onHide = () => {
        setTimeout(() => {
            this.props.setData('newFolder', false, 'FileManager')
            this.props.setData('newUpload', false, 'FileManager')
        }, 1000);
    }

    openNote = () => {

    }

    render() {
        return (
            <div className='scroll-no-scrollbar w-100 d-flex flex-column window-content-radius-top' style={{ zIndex: 10, background: this.props.colors ? this.props.colors.background : 'linear-gradient(90deg, rgb(245 139 0), red)', }}>
                <div className='headerDrive headerDriveSize d-flex w-100 flex-column h-100' style={{ justifyContent: 'space-between' }}>
                    <div className='flexcb py-2 ' style={{ minHeight: '56px' }}>
                        <div className="flexc px-2">
                            {this.props.isApplet
                                ? <div className='flexc'>
                                    <img onClick={() => this.props.goToHub()} className='flexc cursor-pointer' src={imageAddress(this.props.applet?.hub?.image, 'profile', 'small')} width={34} height={34} style={{ objectFit: 'cover', borderRadius: 100 }} draggable={false} />
                                    <div className='flexcb  ' >
                                        <div className='mld-2 flexc'>
                                            <p className="m-0 text-normal text-semibold mb-0 white flexc" style={{ maxWidth: 450 }}>{checkTranslation(this.props.applet?.name)}
                                                <span onClick={() => this.props.goToHub()} className='flexc mld-2  cursor-pointer' >
                                                    <span className="mt-0 text-smaller white opacity-7" >/ {this.props.applet?.hub?.fullname}</span>
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flexcc" style={{ justifyContent: 'left' }}>
                                        {Array.isArray(this.props.paths) && this.props.paths.length > 1 &&
                                            <DirectoryPathIndicator paths={this.props.paths} onChangeDirectory={this.props.onChangeDirectory} language={this.props.language} />
                                        }
                                    </div>
                                </div>
                                :
                                <div className='d-flex'>
                                    <h2 className="m-0 text-big mb-0 pld-2 font-size-24 prd-2" style={{ color: '#fff' }}>{translate('Drive')}</h2>
                                    <div className="flexcc" style={{ justifyContent: 'left' }}>
                                        {Array.isArray(this.props.paths) && this.props.paths.length > 1 &&
                                            // !this.props.isLoadingData &&
                                            <DirectoryPathIndicator paths={this.props.paths} onChangeDirectory={this.props.onChangeDirectory} language={this.props.language} />
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                        <div className='flexcc px-2' style={{}}>
                            <button className="flexcc p-1 mrd-1" onClick={() => { this.setState({ showSearchBox: !this.state.showSearchBox }); this.props.filterFiles(''); this.setState({ show: !this.state.show }) }}>
                                <img src="/assets/icons/applets/drive/search-white.svg" width={25} style={{}} draggable={false} />
                            </button>
                            {/* {(!this.props.isApplet || this.props.adminView) &&
                                <button className="flexcc p-1 mrd-1" onClick={() => this.props.folderModal()}>
                                    <img src="/assets/icons/applets/drive/newfolder-white2.svg" alt="" width={25} draggable={false} />
                                </button>
                            } */}
                            {/* {(!this.props.isApplet || this.props.adminView) &&
                                <button className="flexcc p-1 mrd-1" onClick={() => (this.props.uploadModal(), this.moreFixedView.hideView())}>
                                    <img src="/assets/icons/applets/drive/upload-white.svg" alt="" width={25} draggable={false} />
                                </button>
                            } */}
                            {/* <button className="flexcc" ref={el => this.moreCurrentNode = el} onClick={() => this.moreFixedView.showView()}>
                                <img src="/assets/icons/applets/drive/more-white.svg" alt="" width={25} style={{ transform: 'rotate(90deg)', }} draggable={false} />
                            </button> */}
                        </div>
                    </div>
                    <Collapsible open={this.state.show}>
                        <div className=' w-100 flexcc pb-2 px-2'>
                            <div className='flexcc bg-white br-10 w-100' style={{ border: '1px solid #dadce0', padding: "2px 10px", maxWidth: "400px" }}>
                                <input type="text" placeholder={translate('Search')} onChange={(e) => this.filterFiles(e.target.value)} className='transparent-input px-2 ' />
                                <img className='cursor-pointer' src="/assets/icons/search.svg" alt="" style={{ opacity: '0.8' }} draggable={false} />
                            </div>
                        </div>
                    </Collapsible>
                    {/* linear-gradient(90deg, #005232, #009b5f) */}
                    {(!this.props.isApplet || this.props.adminView) &&
                        <div className='flexcb w-100 sc-2 p-2' style={{ background: 'rgba(255, 255, 255, 0.04)', height: '46px', overflow: 'auto' }}>
                            <div className='flexc'>
                                {console.log('this,propsgf', this.props)}
                                {!this.props.isApplet &&
                                    <SelectApplet type='Drive' ref={el => this.selectApplet = el} setData={this.props.setCurrentApplet} setDataMain={this.props.setData} functionHandler={this.functionHandler} onHide={this.onHide} currentAppletName={this.props.currentAppletName} currentApplet={this.props.currentApplet} />
                                }
                                <DriveFrame language={this.props.language} width={this.props.width} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} changeTab={this.props.changeTab} changeFrame={this.props.changeFrame} leftSideBarPage={this.props.leftSideBarPage} frame={this.props.frame} />
                                <button className='mrd-2 flexcc dark-blur-hover px-2 br-5 py-1' ref={el => this.new = el} onClick={() => { this.newView.showView() }}>
                                    <p className=' font-size-13 white'>{translate('drives.New')}</p>
                                </button>
                                <button className='mrd-2 flexcc dark-blur-hover px-2 br-5 py-1' ref={el => this.sort = el} onClick={() => { this.sortView.showView() }}>
                                    <p className=' font-size-13 white'>{translate('drives.Sort')}</p>
                                </button>
                                <button className='mrd-2 flexcc dark-blur-hover px-2 br-5 py-1' ref={el => this.view = el} onClick={() => { this.viewView.showView() }}>
                                    <p className=' font-size-13 white'>{translate('drives.View')}</p>
                                </button>
                                <button className='mrd-2 flexcc dark-blur-hover px-2 br-5 py-1' ref={el => this.options = el} onClick={() => { this.optionsView.showView() }}>
                                    <p className=' font-size-13 white'>{translate('drives.Options')}</p>
                                </button>
                            </div>
                        </div>
                    }
                </div>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.newView = el} nodeRef={this.new} xOffset={this.props.language == 'fa' ? 205 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3'>
                        <div className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                            <div className=''>
                                <IntractionActionsList onClick={() => this.folderModal()} data={{ title: "{{lang}}drives.Folder", shortcut: 'Ctrl+Z', icon: importedIcons.folderPlus }} />
                                <IntractionActionsList onClick={() => (this.uploadModal())} data={{ title: "{{lang}}drives.Upload", shortcut: 'Ctrl+Z', icon: importedIcons.upload }} />
                                <IntractionActionsList onClick={() => (this.openNote())} data={{ title: "{{lang}}drives.Note", shortcut: 'Ctrl+Z', icon: importedIcons.upload }} />
                                <IntractionActionsList onClick={() => (this.props.openTemplatesModal())} data={{ title: "{{lang}}drives.Template", shortcut: 'Ctrl+Z', icon: importedIcons.upload }} />
                                <IntractionActionsList data={{ title: "{{lang}}drives.Shortcut", shortcut: 'Ctrl+Y', icon: importedIcons.shortcut }} />
                                {/* <IntractionActionsList data={{ title: "{{lang}}drive.Bitmap image", shortcut: 'Ctrl+Y', icon: "/assets/icons/drive/image.svg" }} /> */}
                                <IntractionActionsList data={{ title: "{{lang}}drives.Yonnect Notebook", shortcut: 'Ctrl+Y', icon: importedIcons.notebook }} />
                                <IntractionActionsList data={{ title: "{{lang}}drives.WinRAR ZIP archive", shortcut: 'Ctrl+Y', icon: importedIcons.winrarZip }} />
                                <IntractionActionsList data={{ title: "{{lang}}drives.WinRAR archive", shortcut: 'Ctrl+Y', icon: importedIcons.archive }} />
                            </div>
                        </div>
                    </div>
                </FixedView>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.optionsView = el} nodeRef={this.options} xOffset={this.props.language == 'fa' ? 185 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3'>
                        <div className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                            <div className=''>
                                <div className='mb-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Undo", icon: importedIcons.undo }} />
                                </div>
                                <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Pin to Quick access", icon: importedIcons.pin }} />
                                </div>
                                <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Select all", icon: importedIcons.selectAll }} />
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Select none", icon: importedIcons.selectNone }} />
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Invert Selection", icon: importedIcons.invertSelect }} />
                                </div>
                                <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Properties", icon: importedIcons.properties }} />
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Options", icon: importedIcons.setting }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </FixedView>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.sortView = el} nodeRef={this.sort} xOffset={this.props.language == 'fa' ? 170 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3'>
                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'sort'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className='mb-2'>
                                    <IntractionActionsList onClick={() => { this.props.sortList('name') }} data={{ title: "{{lang}}drives.Name", check: this.props.currentSort.type == 'name' ? true : false }} />
                                    <IntractionActionsList onClick={() => { this.props.sortList('modifiedDate') }} data={{ title: "{{lang}}drives.Date modified", check: this.props.currentSort.type == 'modifiedDate' ? true : false }} />
                                    <IntractionActionsList onClick={() => { this.props.sortList('type') }} data={{ title: "{{lang}}drives.Type", check: this.props.currentSort.type == 'type' ? true : false }} />
                                    <IntractionActionsList onClick={() => { this.props.sortList('size') }} data={{ title: "{{lang}}drives.Size", check: this.props.currentSort.type == 'size' ? true : false }} />
                                    <IntractionActionsList onClick={() => { this.props.sortList('createdDate') }} data={{ title: "{{lang}}drives.Date created", check: this.props.currentSort.type == 'createdDate' ? true : false }} />
                                    {/* <IntractionActionsList onClick={() => { this.props.sortList('authors') }} data={{ title: "{{lang}}drives.Authors", check: this.props.currentSort.type == 'authors' ? true : false }} /> */}
                                    {/* <IntractionActionsList onClick={() => { this.props.sortList('tags') }} data={{ title: "{{lang}}drives.Tags", check: this.props.currentSort.type == 'tags' ? true : false }} /> */}
                                    <IntractionActionsList onClick={() => { this.props.sortList('title') }} data={{ title: "{{lang}}drives.Title", check: this.props.currentSort.type == 'title' ? true : false }} />
                                    {/* <IntractionActionsList onClick={() => this.changePageSubMenu('More')} data={{ title: "{{lang}}drives.More", sub: true }} language={this.props.language} /> */}
                                </div>
                                <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList onClick={() => { this.props.sortList('ascending') }} data={{ title: "{{lang}}drives.Ascending", check: this.props.currentSort.mode == 'ascending' ? true : false }} />
                                    <IntractionActionsList onClick={() => { this.props.sortList('descending') }} data={{ title: "{{lang}}drives.Descending", check: this.props.currentSort.mode == 'descending' ? true : false }} />
                                </div>
                                <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList onClick={() => this.changePageSubMenu('Group by')} data={{ title: "{{lang}}drives.Group by", sub: true }} language={this.props.language} />
                                </div>
                            </div>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={1} stageName={'More'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className=''>
                                    <div className='pb-2'>
                                        <button className='flexc w-100 hover-gray p-2 br-10' onClick={this.lastPage}>
                                            <img width={18} src={importedIcons.arrowLeft} className='rtl-button' />
                                            <p className='font-size-13 weight-500 mld-3 main-c3 text-start'>{translate('drives.Mode')}</p>
                                        </button>
                                    </div>
                                    <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Size", check: true }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Date created", check: true }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Authors", check: true }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Tags", check: true }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Title", check: true }} />
                                    </div>
                                </div>
                            </div>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={1} stageName={'Group by'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className=''>
                                    <div className='pb-2'>
                                        <button className='flexc w-100 hover-gray p-2 br-10' onClick={this.lastPage}>
                                            <img width={18} src={importedIcons.arrowLeft} className='rtl-button' />
                                            <p className='font-size-13 weight-500 mld-3 main-c3 text-start'>{translate('drives.More')}</p>
                                        </button>
                                    </div>
                                    <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Name", check: true }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Date modified", check: true }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Type", check: true }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Size", check: true }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Date created", check: true }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Authors", check: true }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Tags", check: true }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Title", check: true }} />
                                    </div>
                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </FixedView>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.viewView = el} nodeRef={this.view} xOffset={this.props.language == 'fa' ? 175 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3'>
                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'view'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className='mb-2'>
                                    <IntractionActionsList onClick={() => { this.viewStyleShow('extraLargeIcons') }} data={{ title: "{{lang}}drives.Extra large icons", check2: this.state.viewStyle == 'extraLargeIcons' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} />
                                    <IntractionActionsList onClick={() => { this.viewStyleShow('largeIcons') }} data={{ title: "{{lang}}drives.Large icons", check2: this.state.viewStyle == 'largeIcons' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} />
                                    <IntractionActionsList onClick={() => { this.viewStyleShow('mediumIcons') }} data={{ title: "{{lang}}drives.Medium icons", check2: this.state.viewStyle == 'mediumIcons' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} />
                                    <IntractionActionsList onClick={() => { this.viewStyleShow('smallIcons') }} data={{ title: "{{lang}}drives.Small icons", check2: this.state.viewStyle == 'smallIcons' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} />
                                    <IntractionActionsList onClick={() => { this.viewStyleShow('list') }} data={{ title: "{{lang}}drives.List", check2: this.state.viewStyle == 'list' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} />
                                    <IntractionActionsList onClick={() => { this.viewStyleShow('details') }} data={{ title: "{{lang}}drives.Details", check2: this.state.viewStyle == 'details' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} />
                                    <IntractionActionsList onClick={() => { this.viewStyleShow('tiles') }} data={{ title: "{{lang}}drives.Tiles", check2: this.state.viewStyle == 'tiles' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} />
                                    <IntractionActionsList onClick={() => { this.viewStyleShow('content') }} data={{ title: "{{lang}}drives.Content", check2: this.state.viewStyle == 'content' ? true : false, icon: "/assets/icons/note/view/mode.svg" }} />
                                </div>
                                <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Compact view", icon: "/assets/icons/note/view/mode.svg" }} />
                                </div>
                                <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList onClick={() => this.changePageSubMenu('Show')} data={{ title: "{{lang}}drives.Show", sub: true, icon: "/assets/icons/note/view/mode.svg" }} language={this.props.language} />
                                </div>
                            </div>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={1} stageName={'Show'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                                <div className=''>
                                    <div className='pb-2'>
                                        <button className='flexc w-100 hover-gray p-2 br-10' onClick={this.lastPage}>
                                            <img width={18} src={importedIcons.arrowLeft} className='rtl-button' />
                                            <p className='font-size-13 weight-500 mld-3 main-c3 text-start'>{translate('drives.Show')}</p>
                                        </button>
                                    </div>
                                    <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Navigation", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                    </div>
                                    <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Details pane", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Preview pane", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                    </div>
                                    <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Item check boxes", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.File name extentions", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                        <IntractionActionsList data={{ title: "{{lang}}drives.Hidden items", check2: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                    </div>
                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </FixedView>
                <FixedView ref={(el) => (this.fixedView = el)} nodeRef={this.currentNode} width={140} showFocus={false} xOffset={-5} topOffset={6} zIndex={12}>
                    <div className='shadow-2 px-1 br-10' style={{ backgroundColor: "#fff", }}>
                        {this.state.sorting.map((item, index) => {
                            return (
                                <div className=" flexcc py-1 bb-gray flex-column" style={{ alignItems: "flex-start" }}>
                                    <button className="flexc cursor-pointer w-100" onClick={() => { this.props.sortList(item.key); this.sortFixedView() }}>
                                        <div className="flexcb hover-fields-item w-100 p-1" style={{}}>
                                            <p className="text-smaller" style={{ color: '#777' }}>{checkTranslation(item.name)}</p>
                                            {this.props.currentSort && this.props.currentSort.type && this.props.currentSort.type == item.key &&
                                                <img className="mx-1" src="/assets/icons/applets/drive/accept.svg" width={15} draggable={false} />
                                            }
                                        </div>
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                </FixedView>
                <FixedView ref={(el) => (this.moreFixedView = el)} nodeRef={this.moreCurrentNode} width={180} showFocus={false} topOffset={10} xOffset={this.props.language == 'fa' ? 0 : 150} zIndex={11}>
                    <div className='shadow-2 br-10' style={{ backgroundColor: "#fff", }}>
                        <div className="flexcc flex-column cursor-pointer" style={{ alignItems: "flex-start" }} onClick={() => this.sortFixedView()}>
                            <div style={{ width: '100%', padding: '0rem .3rem' }}>
                                <button className="flexc w-100  py-1 " style={{ borderBottom: '1px solid #eee' }} ref={(el) => (this.currentNode = el)}>
                                    <div className="flexcb w-100 hover-fields-item p-1">
                                        <p className='text-smaller pld-1' style={{ color: '#777' }}>{translate('drives.Sort by')}</p>
                                        <img src="/assets/icons/applets/drive/sorting-gray-top.svg" alt="" width={22} draggable={false} />
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div className="flexcc flex-column cursor-pointer" style={{ alignItems: "flex-start" }} onClick={() => (this.folderShow())}>
                            <div style={{ width: '100%', padding: '0rem .3rem' }}>
                                <button className="flexc w-100  py-1 " style={{}}>
                                    <div className="flexcb w-100 hover-fields-item p-1">
                                        <p className='text-smaller pld-1' style={{ color: '#777' }}>{translate('drives.Layout')}</p>
                                        <img src={this.state.listStyle === true
                                            ? "/assets/icons/applets/drive/sortby.svg"
                                            : "/assets/icons/applets/drive/gridview.svg"
                                        } alt="" width={24} draggable={false} />
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </FixedView>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, queque: state.queque })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(headerDrive);

